const BASE = '/api/v1';

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

async function request<T>(
  method: string,
  path: string,
  body?: unknown,
): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    let message = `請求失敗（${res.status}）`;
    try {
      const data = (await res.json()) as {
        message?: string | string[];
        error?: string | string[];
      };
      const detail = data.error ?? data.message;
      if (detail) {
        message = Array.isArray(detail) ? detail.join('、') : detail;
      }
    } catch {
      // non-JSON error body; keep default message
    }
    throw new ApiError(res.status, message);
  }

  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

async function upload<T>(path: string, form: FormData): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    credentials: 'include',
    body: form,
  });
  if (!res.ok) {
    let message = `上傳失敗（${res.status}）`;
    try {
      const data = (await res.json()) as {
        message?: string | string[];
        error?: string | string[];
      };
      const detail = data.error ?? data.message;
      if (detail) message = Array.isArray(detail) ? detail.join('、') : detail;
    } catch {
      // keep default
    }
    throw new ApiError(res.status, message);
  }
  return (await res.json()) as T;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  delete: <T>(path: string) => request<T>('DELETE', path),
  upload: <T>(path: string, form: FormData) => upload<T>(path, form),
};
